import Serializer from 'umg-ember-backend/serializers/application';

export default class ChannelSerializer extends Serializer {
  attrs = {
    asset: 'assetId',
    belonging: 'belongsTo',
    channel: 'channelId',
    link: 'linkId',
  };
}
